import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import styles from './styles.module.sass';

class EditDescription extends PureComponent {
  state = {
    text: ''
  };

  onOk = () => {
    const {text} = this.state;
    const tx = text.trim();

    const {onOk} = this.props;
    if(onOk) onOk(tx);
    this.setState({text: ''});
  };

  onCancel = () => {
    const {onCancel} = this.props;
    if (onCancel) onCancel();
  };

  componentWillMount() {
    const {defaultText} = this.props;
    this.setState({text: defaultText})
  }

  handlerOnChange = (e) => {
    let text = e.target.value;
    const max = 500;
    if (text && text.length > max) {
      text = text.slice(0, max);
    }


    this.setState({error: false, text});
  };

  inputRef;
  focusTextField = ref => {
    if (!this.inputRef) {
      ref.focus();
      this.inputRef = ref;
    }
  };

  render() {
    const {text, error} = this.state;
    return (
      <div className={cx(styles.box)}>
        <Paper className={cx(styles.textBox)}>
          <Typography className={styles.header}>Редактирование описания</Typography>
          <div className={styles.body}>
            <TextField
              inputRef={this.focusTextField}
              error={error}
              className={styles.textField}
              value={text}
              onChange={this.handlerOnChange}
              multiline={true}
              rows={7}
            />

            <div className={cx(styles.bottom)}>
              <Button variant='contained' color='primary' className={styles.button} onClick={this.onOk}>Подтвердить</Button>
              <Button variant='contained' className={styles.button} onClick={this.onCancel}>Отмена</Button>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

EditDescription.propTypes = {
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  defaultText: PropTypes.string
};

export default EditDescription;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCaseEditor/AttachFiles/EditDescription.jsx